







import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../../core/store";
import ProgramMedia from "../programs/ProgramMedia.vue";

@Component({
  components: { ProgramMedia },
})
export default class GuidelineSessionContent extends Vue {
  @Prop({ type: Object, required: true }) session!: any;

  get images(): string[] {
    return this.session.images.map((p: string) => store.state.settings.Uploads + "/" + p);
  }
}
